import type { Accessor } from 'solid-js';

/** Wall-clock session date for LIVE dataset rows (matches server_stream UTC date). */
export function getLiveSessionDateYmd(): string {
  const d = new Date();
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Prefer LIVE context date from store (sidebar / simulation), else UTC today. */
export function getLiveQueryDateYmd(selectedDate: Accessor<string> | (() => string)): string {
  const fromStore = (selectedDate() || '').trim();
  if (fromStore && fromStore !== '0') {
    return fromStore;
  }
  return getLiveSessionDateYmd();
}
